import { Component, ViewChild, ElementRef, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { SetPinType } from 'src/app/models/account';

@Component({
  selector: 'app-input-pin',
  templateUrl: './input-pin.component.html',
  styleUrls: ['./input-pin.component.css']
})
export class InputPinComponent implements OnInit{
  @Output() setPin: EventEmitter<string> = new EventEmitter<string>();
  @Input() pinStep: SetPinType;

  @ViewChild('1') field1: ElementRef;
  @ViewChild('2') field2: ElementRef;
  @ViewChild('3') field3: ElementRef;
  @ViewChild('4') field4: ElementRef;
  @ViewChild('5') field5: ElementRef;
  @ViewChild('6') field6: ElementRef;

  num1: string = '';
  num2: string = '';
  num3: string = '';
  num4: string = '';
  num5: string = '';
  num6: string = '';

  title: string;
  description: string;
  errorMessage: string = '';
  constructor() { }

  get getPinStep() { return SetPinType;}

  ngOnInit(){
    switch(this.pinStep){
      case SetPinType.AskPin:
        this.title = 'Pesanan Melebihi Limit';
        this.description = 'Masukan PIN anda';
        break;
      case SetPinType.CurrentPin:
        this.title = 'Masukan PIN Lama Anda';
        this.description = 'Masukan PIN anda saat ini';
        break;
      case SetPinType.NewPin:
        this.title = 'Masukan PIN Baru';
        this.description = 'Masukan PIN baru anda';
        break;
      case SetPinType.ConfirmPin:
        this.title = 'Ulangi PIN';
        this.description = 'Ulangi pin anda';
        break;
      case SetPinType.UpdateLimit:
        this.title = 'Update Limit';
        this.description = 'Masukan PIN anda';
        break;
    }
    this.field1.nativeElement.focus();
  }
  filterNumeric(num:number){
    switch(num){
      case 1:
        this.num1 = this.num1.replace(/\D/g,'');
        if(this.num1 != ''){
          this.num2 = '';
          this.field2.nativeElement.focus();
        }
        break;
      case 2:
        this.num2 = this.num2.replace(/\D/g,'');
        if(this.num2 != ''){
          this.num3 = '';
          this.field3.nativeElement.focus();
        }
        break;
      case 3:
        this.num3 = this.num3.replace(/\D/g,'');
        if(this.num3 != ''){
          this.num4 = '';
          this.field4.nativeElement.focus();
        }
        break;
      case 4:
        this.num4 = this.num4.replace(/\D/g,'');
        if(this.num4 != ''){
          this.num5 = '';
          this.field5.nativeElement.focus();
        }
        break;
      case 5:
        this.num5 = this.num5.replace(/\D/g,'');
        if(this.num5 != ''){
          this.num6 = '';
          this.field6.nativeElement.focus();
        }
        break;
      case 6:
        this.num6 = this.num6.replace(/\D/g,'');
        break;
    }
  }
  backspace(num: number){
    switch(num){
      case 2:
        if(this.num2 == ''){
          this.num1 = '';
          this.field1.nativeElement.focus();
        }
        break;
      case 3:
        if(this.num3 == ''){
          this.num2 = '';
          this.field2.nativeElement.focus();
        }
        break;
      case 4:
        if(this.num4 == ''){
          this.num3 = '';
          this.field3.nativeElement.focus();
        }
        break;
      case 5:
        if(this.num5 == ''){
          this.num4 = '';
          this.field4.nativeElement.focus();
        }
        break;
      case 6:
        if(this.num6 == ''){
          this.num5 = '';
          this.field5.nativeElement.focus();
        }
        break;
    }
  }
  next(isValid: boolean){
    this.errorMessage = '';
    if(isValid){
      const pin = this.num1 + this.num2 + this.num3 + this.num4 + this.num5 + this.num6;
      this.setPin.emit(pin);
    }
  }
  showError(message: string){
    this.errorMessage = message;
    this.num1 = '';
    this.num2 = '';
    this.num3 = '';
    this.num4 = '';
    this.num5 = '';
    this.num6 = '';
    this.field1.nativeElement.focus();
  }

}
